import { Alert, MenuItem, Popover, Typography } from "@mui/material";

interface LegendPopoverProps {
  anchorElement: Element | undefined;
  handleCloseMenu: () => void;
}
export const LegendPopover = ({
  anchorElement,
  handleCloseMenu,
}: LegendPopoverProps) => {
  return (
    <Popover
      style={{ pointerEvents: "none" }}
      open={Boolean(anchorElement)}
      anchorEl={anchorElement}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: "center", horizontal: "left" }}
      transformOrigin={{ vertical: "center", horizontal: "right" }}
      PaperProps={{
        sx: {
          p: 1,
          width: 200,
          "& .MuiMenuItem-root": {
            px: 1,
            typography: "body2",
            borderRadius: 0.75,
          },
        },
      }}
    >
      <MenuItem key={`menu-item-total`}>
        <Alert
          variant="filled"
          severity={"success"}
          sx={{
            margin: "auto !important",
            "& .MuiAlert-icon": { margin: "auto important!" },
          }}
        >
          Report Submitted
        </Alert>
      </MenuItem>
      <MenuItem key={`menu-item-overall-target`}>
        <Alert
          variant="filled"
          severity={"info"}
          sx={{
            margin: "auto !important",
            "& .MuiAlert-icon": { margin: "auto important!" },
          }}
        >
          Report In Progress
        </Alert>
      </MenuItem>
      <MenuItem key={`menu-item-overall-target`}>
        <Alert
          variant="filled"
          severity={"warning"}
          sx={{
            margin: "auto !important",
            "& .MuiAlert-icon": { margin: "auto important!" },
          }}
        >
          Report Up Coming
        </Alert>
      </MenuItem>
      <MenuItem key={`menu-item-projected-value`}>
        <Alert
          variant="filled"
          severity={"error"}
          sx={{
            margin: "auto !important",
            width: "100%",
            flexGrow: 1,
          }}
        >
          Report Overdue
        </Alert>
      </MenuItem>
    </Popover>
  );
};
